import React, { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import ApiCallServices from "../../../../services/ApiCallServices"
import { END_POINTS } from '../../../../services/endpoint/endPoint';
import DealsTable from "./child/DealsTable"
import button from "../../../button.module.css"
import { useLocation } from 'react-router-dom';

const initialDeal = {
    deal_code: '',
    deal_name: ''
}
const Deals = () => {
    const [tableData, setTableData] = useState([]);
    const [search, setSearch] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState(null)
    const [partnerList, setPartnerList] = useState([])
    const [demandList, setDemandList] = useState([])
    const [selectedDemand, setSelectedDemand] = useState()
    const [newDeal, setNewDeal] = useState(initialDeal);
    const [filterPartner, setFilterPartner] = useState()
    const [errors, setErrors] = useState({})

    const [selectedNewDemand, setSelectedNewDemand] = useState()

    const [sortingColumn, setSortingColumn] = useState(null);
    const [sortingOrder, setSortingOrder] = useState('asc');

    const [showHideModal, setShowHideModal] = useState(false)

    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const isNavigatedFromSupplyPartner = useRef(false);
    const [agencyList, setAgencyList] = useState([])
    const [brandList, setBrandList] = useState([])
    const [countryList, setCountryList] = useState([])

    
    

    useEffect(() => {
        if (location.state && location.state.id && location.state.name) {
            isNavigatedFromSupplyPartner.current = true;
            setFilterPartner({ id: location.state.id, name: location.state.name });
        }
    }, [location.state]);


    useEffect(() => {
        if (isNavigatedFromSupplyPartner.current) {

            if (filterPartner && filterPartner.id) {
                console.log("Fetching deals for navigated client_id:", filterPartner.id);
                getDealsTableData(filterPartner.id);
            }
        } else {
            getDealsTableData()
            // if (filterPartner) {
            //     if (filterPartner.id) {
            //         console.log("Fetching deals for manually selected client_id:", filterPartner.id);
            //         getDealsTableData(filterPartner.id);
            //     } else {
            //         console.log("Fetching deals for empty client_id:");
            //         getDealsTableData('');  
            //     }
            // }
        }
    }, [filterPartner, search, sortingColumn, sortingOrder, selectedDemand]);





    const getDealsTableData = (client_id) => {
        setLoader(true);
        const data = {
            name: search,
            client_id: filterPartner?.id || client_id || '',
            sortingcolumn: sortingColumn,
            sortingorder: sortingOrder,
            demand_id: selectedDemand?.id || ''
        };

        ApiCallServices.create(END_POINTS.dealsTableData, data)
            .then(res => {
                if (res.status === 200) {
                    setTableData(res.data.data);
                }
            })
            .catch(error => {
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: 'top-right',
                    });
                }
            })
            .finally(() => setLoader(false));
    };



    const supply = sessionStorage.getItem('sp');
    const supplypartner = JSON.parse(supply);
    console.log(supplypartner, 'supplypartner');


    useEffect(() => {
        if (supplypartner) {
            setFilterPartner(supplypartner);
        }
    }, [supplypartner]);





    // useEffect(() => {
    //   if (filterPartner || search || sortingColumn || sortingOrder) {
    //     getDealsTableData();
    //   }
    // }, [filterPartner, search, sortingColumn, sortingOrder]); // Only runs when these dependencies change


    console.log(filterPartner, "filterPartner")
    const deleteDeal = (id) => {
        ApiCallServices.create(END_POINTS.deleteDeal, { id: id }).then((res) => {
            if (res.status == 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                getDealsTableData();
            }
        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });
    }

    const confirmDelete = (id) => {
        if (window.confirm('Are you sure you want to delete the Deal')) {
            deleteDeal(id);
        }
    }

    const updateDealStatus = (id, status) => {
        ApiCallServices.create(END_POINTS.updateDealStatus, { id: id, status: status }).then((res) => {
            if (res.status == 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                getDealsTableData();
            }

        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });

    }

    const confirmUpdate = (id, status) => {
        if (window.confirm('Are you sure you want to Update the status')) {
            updateDealStatus(id, status);
        }
    }

    const searchDeal = (e) => {
        if (e.target.value.length > 1) {
            setSearch(e.target.value);
        } else {
            setSearch('');
        }
    }

    const handleSelectChange = (selectedValue) => {
        setSelectedPartner(selectedValue);
    }

    const handleSort = (column) => {
        if (sortingColumn === column) {
            setSortingOrder(sortingOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortingColumn(column);
            setSortingOrder('asc');
        }
    };

    const getPartnerList = () => {
        ApiCallServices.getlisting(END_POINTS.partnerList).then((res) => {
            if (res.status == 200) {
                setPartnerList(res.data.data);
                setSelectedPartner(res.data.data[0])
            }
        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });
    }

    useEffect(() => {
        getPartnerList();
    }, [])

    const handleInputChange = (e) => {
        setNewDeal({ ...newDeal, [e.target.name]: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        //validation
        const validationError = {}

        if (!newDeal?.deal_code) {
            validationError.deal_code = "Deal id is required"
        }
        if (!newDeal?.deal_name) {
            validationError.deal_name = "Deal name is required"
        }
        if (!selectedPartner) {
            validationError.selectedPartner = "Please select supply partner"
        }
        setErrors(validationError)

        if (Object.keys(validationError).length === 0) {
            const obj = {
                deal_code: newDeal.deal_code,
                deal_name: newDeal.deal_name,
                supply_partner: selectedPartner.id,
                demand_partner_id: selectedNewDemand?.id || null
            }
            ApiCallServices.create(END_POINTS.createDeal, obj).then((res) => {
                if (res.status == 200) {
                    toast.success(res.data.message, {
                        position: "top-right"
                    });
                    setNewDeal(initialDeal);
                    setSelectedPartner(partnerList[0])
                    document?.body?.removeAttribute('style');
                    setShowHideModal(false)
                    getDealsTableData();
                }
            })
                .catch((error) => {
                    // Handle errors here
                    if (error.response) {
                        toast.error(error.response.data.error, {
                            position: "top-right"
                        });
                        console.log(error.response, "===>error in getting response");
                    }
                });
        }


    }

    const handleFormReset = () => {
        setNewDeal(initialDeal);
        setShowHideModal(false)
        document?.body?.removeAttribute('style');
        setErrors({})

    }
    const patnerFilterChange = (value) => {
        if (value) {
            isNavigatedFromSupplyPartner.current = false;
            setFilterPartner(value);
        } else {
            setFilterPartner(null);
            getDealsTableData('');
        }
    };

    const handleHideShowModal = () => {
        setShowHideModal(true)
        document.body.style = 'overflow: hidden'
    }

    const getDemandPartnerList = () => {
        ApiCallServices.getlisting(END_POINTS.demandPartnerList).then((res) => {
            console.log(res)
            if (res.status == 200) {
                setDemandList(res.data.data)
            }
        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });

    }

    console.log(demandList, "DEMAND((((***")
    useEffect(() => {
        getDemandPartnerList()
    }, [])

    const demandFilterChange = (value) => {
        setSelectedDemand(value)
    }

    const handleNewDemandChange = (value) => {
        setSelectedNewDemand(value)
    }

    const mapDemandPartner = (val, dealId) => {
        let data = {
            demand_partner_id: val?.id,
            deal_id: dealId,
        }
        ApiCallServices.create(END_POINTS.mapDealDemandFromTable, data).then((res) => {
            if (res.status == 200) {
                // getDealsTableData()
                toast.success(res.data.message, {
                    position: "top-right"
                });
            }
        })
            .catch((error) => {
                // Handle errors here
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });

    }

    const getAgencyList = () => {
        let data = {

        }
        ApiCallServices.create(END_POINTS.agencyList, data).then((res) => {
            if (res.status === 200) {
                setAgencyList(res.data.data)
            }
        })
    }

    const getBrandList = () => {
        let data = {

        }
        ApiCallServices.create(END_POINTS.brandList, data).then((res) => {
            if (res.status === 200) {
                setBrandList(res.data.data)
            }
        })
    }


    const getCountryList = () => {
        let data = {

        }
        ApiCallServices.getlisting(END_POINTS.countryList, data).then((res) => {
            if (res.status === 200) {
                setCountryList(res.data.data)
            }
        })
    }

    useEffect(() => {
        getAgencyList();
        getBrandList();
        getCountryList();
    }, [])

    const mapAgency = (val, dealId) => {
        let data = {
            agency_id: val?.id,
            deal_id: dealId || null
        }
        ApiCallServices.create(END_POINTS.mapAgency, data).then((res) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                // getDealsTableData()
                console.log(res)
            }
        })
    }

    const mapBrand = (val, dealId) => {
        let data = {
            brand_id: val?.id,
            deal_id: dealId || null
        }
        ApiCallServices.create(END_POINTS.mapBrand, data).then((res) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                // getDealsTableData()
                console.log(res)
            }
        })
    }

    const mapCountry = (val, dealId) => {
        let data = {
            ccode: val?.ccode,
            deal_id: dealId || null
        }
        ApiCallServices.create(END_POINTS.mapCountry, data).then((res) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                console.log(res)
            }
        })
    }

    console.log(agencyList, "***agencyList")

    return (
        <>
            <ToastContainer />
            <div className="container-fluid">
            <div className='filter-wraper justify-content-between'>
                <div className='d-flex align-items-center fields'>
                    <h3>Manage Deals</h3>
                </div>
            </div>
                <div className='filter-wraper justify-content-between'>
                    <div className='d-flex align-items-center fields'>
                        <div className='form-group search-icon'>
                            <input type='text' className='form-control' onChange={searchDeal} placeholder='Search by patner & deal' />
                        </div>
                        <div className="form-group custome-select">
                            <Select
                                placeholder="Select Supply Partner"
                                isClearable="false"
                                value={filterPartner}
                                onChange={patnerFilterChange}
                                options={partnerList}
                                getOptionLabel={(partnerList) => partnerList.name}
                                getOptionValue={(partnerList) => partnerList.id}
                            />
                        </div>
                        <div className="form-group custome-select">
                            <Select
                                placeholder="Select Demand Partner"
                                isClearable="false"
                                value={selectedDemand}
                                onChange={demandFilterChange}
                                options={demandList}
                                getOptionLabel={(demandList) => demandList.name}
                                getOptionValue={(demandList) => demandList.id}
                            />
                        </div>

                    </div>
                    <div className='form-group d-flex justify-content-end'>
                        {/* <button type="button" className={`${button.btn} ${button.btnDarkBlue}`} data-bs-toggle="modal" data-bs-target="#mapDealClient">Map Deal</button> */}
                        {/* <button type="button" className={`${button.btn} ${button.btnDarkBlue}`} onClick={handleHideShowModal}>Add New Deal</button> */}
                    </div>
                </div>
                <DealsTable tableData={tableData} updateDealStatus={updateDealStatus} onSort={handleSort} delDeal={confirmDelete} updateStatus={confirmUpdate} loader={loader} mapDemandPartner={mapDemandPartner} demandList={demandList} agencyList={agencyList} countryList={countryList} brandList={brandList} mapAgency={mapAgency} mapBrand={mapBrand} mapCountry={mapCountry} />
            </div>

            {/* add new deal */}
            <div className={`modal form-modal ${showHideModal ? 'show' : ''}`}>
                <div className="modal-dialog modal-md">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Add New Deal</h4>
                            <i class="fa-regular fa-circle-xmark close-icon" onClick={handleFormReset}></i>
                        </div>

                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="form-wraper">
                                    <div className="form-group custome-select">
                                        <label>Supply Partner <span class="astric">*</span></label>
                                        <Select
                                            // placeholder="Select Supply Partner"
                                            // isClearable= {false}
                                            // isSearchable = {false}
                                            value={selectedPartner}
                                            onChange={handleSelectChange}
                                            options={partnerList}
                                            defaultValue={partnerList}
                                            getOptionLabel={(partnerList) => partnerList.name}
                                            getOptionValue={(partnerList) => partnerList.id}
                                        />
                                        {errors.selectedPartner && <div className='input-error'>{errors.selectedPartner}</div>}
                                    </div>
                                    <div className="form-group custome-select">
                                        <label>Demand Partner</label>
                                        <Select
                                            placeholder="Select Demand Partner"
                                            value={selectedNewDemand}
                                            onChange={handleNewDemandChange}
                                            options={demandList}
                                            defaultValue={demandList}
                                            getOptionLabel={(demandList) => demandList.name}
                                            getOptionValue={(demandList) => demandList.id}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Deal Code <span class="astric">*</span></label>
                                        <input type="text" placeholder="Deal Id" value={newDeal.deal_code} name="deal_code" onChange={handleInputChange} className="form-control" />
                                        {errors.deal_code && <div className='input-error'>{errors.deal_code}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label>Deal Name <span class="astric">*</span></label>
                                        <input type="text" placeholder="Enter Deal Name" value={newDeal.deal_name} name="deal_name" onChange={handleInputChange} className="form-control" />
                                        {errors.deal_name && <div className='input-error'>{errors.deal_name}</div>}
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className={`${button.btn} ${button.btnBlue}`} >Save</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${showHideModal ? 'overlay' : ''}`}></div>
        </>
    )


}

export default Deals;